(() => {
  const update = () => {
    document.querySelectorAll('[data-product-countdown]').forEach((block) => {
      const remaining = Number(block.dataset.productCountdown) * 1000 - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        block.hidden = true;
        return;
      }
      const seconds = Math.ceil(remaining / 1000);
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600) % 24,
        minutes: Math.floor(seconds / 60) % 60,
        seconds: seconds % 60,
      };
      Object.entries(values).forEach(([unit, value]) => {
        block.querySelector(`[data-countdown-${unit}]`).textContent = String(value).padStart(2, '0');
      });
      block.hidden = false;
    });
  };
  update();
  window.setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
